var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12", grow: "", shrink: "" } },
    [
      _c(
        "w-row",
        { attrs: { center: "" } },
        [
          _vm._t("default"),
          _c("w-spacer"),
          _c(
            "div",
            [
              _c(
                "w-col",
                [
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        {
                          attrs: { disabled: _vm.addDisabled },
                          on: {
                            click: function ($event) {
                              return _vm.addClicked()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          attrs: { disabled: _vm.deleteDisabled },
                          on: {
                            click: function ($event) {
                              return _vm.removeClicked()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "minus" } })],
                        1
                      ),
                      _c(
                        "w-dropdown",
                        {
                          attrs: { items: _vm.dropdownItems, right: "" },
                          on: {
                            click: function ($event) {
                              return _vm.dropdownTrigger($event)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "bars" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-row",
        { attrs: { grow: "", shrink: "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-data-table", {
                staticStyle: { "flex-grow": "1" },
                attrs: {
                  columns: _vm.columns,
                  items: _vm.value.users,
                  "selected-items": _vm.selectedRows,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.addUsersModal } },
        [
          _vm.addUsersModal
            ? _c("app-dossier-users-add-modal", {
                attrs: { value: _vm.value, company: _vm.company },
                on: {
                  input: function ($event) {
                    return _vm.usersAdded($event)
                  },
                  close: function ($event) {
                    _vm.addUsersModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }